import React from 'react';

import { useRouterStore } from 'apps/hooks';
import { CreateTeamFlow } from './createTeamFlow';
import { UpgradeFlow } from './upgradeFlow';

export const Upgrade = () => {
  const routerStore = useRouterStore();

  if (routerStore.route.name === 'home.newInitiative') {
    return <CreateTeamFlow />;
  }

  if (routerStore.route.name === 'workspace.upgrade') {
    return <UpgradeFlow />;
  }

  // make more handle here, if not found the route
  // route to home, instead of return null
  return null;
};
